export const Props = () => ({
  //Активна ли кнопка?
  isActive: { type: Boolean }
});